<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>组织管理</el-breadcrumb-item>
      <el-breadcrumb-item>部门管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <!-- 添加角色信息按钮 -->
      <el-row>
        <el-col>
          <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="addDialogVisible = true" class="btn1">新增</el-button>
        </el-col>
      </el-row>
      <div>
        <!-- 部门信息表格 -->
        <el-table
          :data="departmentList"
          style="width: 100%; margin-bottom: 20px"
          row-key="id"
          default-expand-all
          :tree-props="{children: 'children'}"
        >
          <el-table-column prop="name" label="名称" align="center"> </el-table-column>
          <el-table-column prop="state" label="状态" align="center"> </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <!-- <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button> -->
              <el-button type="text" icon="el-icon-delete" size="mini" @click="removeMenu(scope)">删除</el-button>
              <el-button type="text" icon="el-icon-error" size="mini" @click="disableDepartment(scope)"
                >禁用</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-card>

    <!-- 添加部门的对话框 -->
    <el-dialog title="添加部门" :visible.sync="addDialogVisible" width="25%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="名称" prop="name" required>
          <el-input v-model="addForm.name" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <!-- <el-form-item label="父ID" prop="parentId" required>
          <el-input v-model="addForm.parentId" style="width: 90%" size="medium"></el-input>
        </el-form-item> -->
        <el-form-item label="级别" prop="level" required>
          <el-select v-model="addForm.level" placeholder="请选择部门级别">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <div v-if="addForm.level == '2'">
          <el-form-item label="上级部门" prop="parentId" required>
            <el-select v-model="addForm.parentId" placeholder="请选择上级部门">
              <el-option
                v-for="item in parentDepartmentList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="addDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="addMenu()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑菜单信息的会话框 -->
    <el-dialog title="修改菜单信息" :visible.sync="editDialogVisible" width="40%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="120px">
        <el-form-item label="菜单名" prop="MenuName" required>
          <el-input v-model="editForm.MenuName" style="width: 90%" size="medium"></el-input>
        </el-form-item>
        <div v-if="this.editFormLevel == '2'">
          <el-form-item label="级别" prop="level">
            <el-select v-model="addForm.level" placeholder="请选择菜单级别">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-if="this.editFormLevel == '2' && this.addForm.level == '2'">
          <el-form-item label="路径" prop="path" required>
            <el-input v-model="editForm.path" style="width: 90%" size="medium"></el-input>
          </el-form-item>
        </div>
        <div v-if="this.editFormLevel == '2' && this.addForm.level == '2'">
          <el-form-item label="父ID" prop="ParentID" required>
            <el-select v-model="editForm.ParentID" placeholder="请选择" @change="selectNum($event)">
              <el-option
                v-for="item in parentMenu"
                :key="item.ID"
                :label="item.MenuName"
                :value="{IDS: item.MenuName, code: item.ID}"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="editMenu">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '5000',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms',
                tableName: 'main_menu'
            },
            // 部门信息表
            departmentList: [],
            // 一级部门信息表
            parentDepartmentList: [],
            // 父级菜单信息表
            parentMenu: [],
            // 添加菜单的表单数据
            addForm: {
                name: '',
                parentId: '',
                ParentName: '',
                level: ''
            },
            // 数据总条数
            total: 0,
            //控制添加表单的显示与隐藏
            addDialogVisible: false,
            //控制修改表单的显示与隐藏
            editDialogVisible: false,
            // 编辑信息的表单数据
            editForm: {},
            // 修改表单的验证规则对象
            editFormRules: {
                StorageLocationNO: [
                    { required: true, message: '请输入储位编号', trigger: 'blur' },
                ],
                WarehouseSet_ID: [
                    { required: true, message: '请输入仓库管理标识符', trigger: 'blur' },
                ],
                Main_ProductSet_ID: [
                    { required: true, message: '请输入产品设置标识符', trigger: 'blur' },
                ],
                QTY: [
                    { required: true, message: '请输入产品数量', trigger: 'blur' },
                ],
            },
            //目录级别选择
            options: [{
                value: '1',
                label: '一级'
            }, {
                value: '2',
                label: '二级'
            }],
            // 修改用级别
            editFormLevel: ''
        }
    },
    created () {
        this.getDepartmentList()
        this.getParentDepartmentList()
    },
    methods: {
        // 调用接口获取部门信息
        async getDepartmentList () {
            const { data: res } = await this.$http.get('/User/getDepartment', { params: this.getTypeList })
            console.log(res.data)
            for (let i = 0; i < res.data.length; i++) {
                if (res.data[i].state == '1') {
                    res.data[i].state = '正常'
                } else if (res.data[i].state == '0') {
                    res.data[i].state = '禁用'
                }
            }
            this.departmentList = this.setTreeData(res.data)
        },
        // 获取父级部门信息
        async getParentDepartmentList () {
            const { data: res } = await this.$http.get('/User/getDepartment', { params: this.getTypeList })
            let result = res.data.filter(function (num) {
                return num.parent_id == 0
            })
            this.parentDepartmentList = result
        },
        // 给父级数据添加children属性
        setTreeData (source) {
            let cloneData = JSON.parse(JSON.stringify(source))
            return cloneData.filter(father => {
                let branchArr = cloneData.filter(child => father.id == child.parent_id);
                branchArr.length > 0 ? father.children = branchArr : ''
                return father.parent_id == 0;
            });
        },
        // 调用接口删除部门信息
        async removeMenu (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久删除该信息, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消删除！')
            }
            let params = new URLSearchParams();
            params.append("id", scope.row.id)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log('89' + params)
            const { data: res } = await this.$http.post('/User/DeleteDepartment', params)
            console.log(res)
            if (res.code !== 1) {
                return this.$message.error('删除失败！')
            } else {
                this.$message.success('删除成功！')
            }
            this.getDepartmentList()
            this.getParentDepartmentList()
        },
        // 禁用部门信息
        async disableDepartment (scope) {
            const confirmResult = await this.$confirm(
                '此操作将永久禁用该部门, 是否继续?',
                '提示',
                {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }
            ).catch(err => err)

            if (confirmResult !== 'confirm') {
                return this.$message.info('已经取消禁用！')
            }
            scope.row.state = '0'
            let params = new URLSearchParams();
            params.append("id", scope.row.id)
            params.append("state", scope.row.state)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            console.log('89' + params)
            const { data: res } = await this.$http.post('/User/DisableDepartment', params)
            console.log(res)
            if (res.code !== 1) {
                return this.$message.error('禁用失败！')
            } else {
                this.$message.success('禁用成功！')
            }
            this.getDepartmentList()
            this.getParentDepartmentList()
        },
        //  监听添加信息对话框的关闭事件
        addDialogClosed () {
            this.$refs.addFormRef.resetFields()
        },
        // 调用接口添加部门信息
        addMenu () {
            this.$refs.addFormRef.validate(async valid => {
                if (!valid) return
                if (this.addForm.level == '1') {
                    this.addForm.parentId = '0'
                }
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("name", this.addForm.name)
                params.append("parentId", this.addForm.parentId)
                console.log('554' + params)
                const { data: res } = await this.$http.post('/User/InsertDepartment', params)
                console.log(res.data)
                if (res.code != 1) {
                    return this.$message.error('添加菜单失败！')
                } else {
                    this.$message.success('添加菜单成功！')
                }
                // 隐藏添加信息的对话框
                this.addDialogVisible = false
                // 重新获取仓库储位信息列表数据
                this.getDepartmentList()
            })
        },
        // 监听修改信息对话框的关闭事件
        editDialogClose () {
            this.$refs.editFormRef.resetFields()
        },
        // 展示修改菜单信息的对话框
        async showEditDialog (scope) {
            this.editDialogVisible = true
            let params = new URLSearchParams();
            params.append("ID", scope.row.ID)
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("tableName", this.getTypeList.tableName)
            const { data: res } = await this.$http.get('/WMS/GeneralQueryID', { params })
            console.log(res.data)
            if (res.data[0].ParentID == '0') {
                this.editFormLevel = '1'
                this.addForm.level = '1'
            } else {
                this.editFormLevel = '2'
                this.addForm.level = '2'
            }
            console.log(this.addForm.level)
            this.editForm = res.data[0]
        },
        // 调用接口编辑角色信息
        editMenu () {
            this.$refs.editFormRef.validate(async valid => {
                if (!valid) return
                if (this.addForm.level == '1') {
                    this.editForm.ParentID = '0'
                }
                let params = new URLSearchParams();
                params.append("privateKey", this.getTypeList.privateKey)
                params.append("appIdentification", this.getTypeList.appIdentification)
                params.append("ID", this.editForm.ID)
                params.append("MenuName", this.editForm.MenuName)
                params.append("ParentID", this.editForm.ParentID)
                params.append("path", this.editForm.path)
                params.append("ParentName", this.editForm.ParentName)
                console.log('123' + params)
                const { data: res } = await this.$http.post('/User/UpdateMenu', params)
                console.log(res)
                if (res.code != 1) {
                    return this.$message.error('更新菜单信息失败！')
                } else {
                    this.$message.success('更新菜单信息成功！')
                }
                // 关闭对话框
                this.editDialogVisible = false
                // 刷新数据列表
                this.getMenuList()
            })
        },
    }
}
</script>

<style lang="less" scoped>
.btn1 {
  margin-bottom: 10px;
}
</style>

